export default "__VITE_ASSET__CSIoJq6M__"